import React from 'react';
import { BoundSearchQuery } from "../../../types/common/BoundSearchQuery";
import { BuyerInvoiceSearchCriteria, BUYER_INVOICES_DATE_BYPASS_KEYS } from "../../../types/model/criteria/invoice/BuyerInvoiceSearchCriteria";
import { PageableParams } from "../../../types/model/params/PageableParams";
import { optionsEndpoints } from "../../../requests/api-endpoints";
import {
  BuyerInvoiceStatusGroup,
  BuyerTransactionTypeOptions
} from "../../constants/booking-transaction-constants";
import {
  SortFilterContainer,
  SortFilterItemContainer,
  SortFilterRowContainer
} from "../../common/reports/sortFilter";
import {
  sortByFields,
  BuyerInvoiceSortByType,
  BuyerInvoiceSortParams
} from "../../../types/model/params/sortParams/BuyerInvoiceSortParams";
import {
  BoundSortSelect,
  BoundDataDrivenAutocomplete,
  BoundTextInput,
  BoundDateRangeFilter,
  BoundSelect
} from "../../common/inputs/boundInputs";

const buyerInvoiceStatusGroupOptions = Object.values(BuyerInvoiceStatusGroup);

export interface BuyerInvoicesSearchParams extends BuyerInvoiceSearchCriteria , BuyerInvoiceSortParams, PageableParams, BoundSearchQuery {}

export interface BuyerInvoicesSortFilterProps {
  query: BuyerInvoicesSearchParams;
  onChange: (newQuery: BuyerInvoicesSearchParams) => void;
}

const BuyerInvoicesSortFilter = ({
  query,
  onChange
}: BuyerInvoicesSortFilterProps) => {
  return <SortFilterContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundDataDrivenAutocomplete<BuyerInvoicesSearchParams>
          label="Location"
          requestUrl={optionsEndpoints.buyer.location}
          name="locationId"
          value={query?.locationId}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <BoundDateRangeFilter<BuyerInvoicesSearchParams>
        query={query}
        onChange={onChange}
        dateBypassKeys={BUYER_INVOICES_DATE_BYPASS_KEYS}
        idSearchLabel="booking or invoice number"
      />
    </SortFilterRowContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundTextInput<BuyerInvoicesSearchParams>
          label="Booking Number"
          name="orderNumber"
          numeric
          minLength={3}
          value={query?.orderNumber}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundTextInput<BuyerInvoicesSearchParams>
          label="Invoice Number"
          name="transactionNumber"
          numeric
          minLength={3}
          value={query?.transactionNumber}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundSortSelect<BuyerInvoicesSearchParams, BuyerInvoiceSortByType>
          query={query}
          defaultSortBy="TRANSACTION_NUMBER"
          defaultSortDir="desc"
          sortByFields={sortByFields}
          onChange={onChange}
        />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundSelect<BuyerInvoicesSearchParams>
          options={BuyerTransactionTypeOptions}
          label="Invoice Type"
          name="transactionType"
          value={query?.transactionType}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundSelect<BuyerInvoicesSearchParams>
          options={buyerInvoiceStatusGroupOptions}
          label="Status"
          name="buyerTransactionStatus"
          value={query?.buyerTransactionStatus}
          onChange={onChange}
        />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
  </SortFilterContainer>
}

export { BuyerInvoicesSortFilter };